import { baggageHeaderToDynamicSamplingContext } from './baggage.js';
import { uuid4 } from './misc.js';
var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
'([0-9a-f]{32})?' + // trace_id
'-?([0-9a-f]{16})?' + // span_id
'-?([01])?' + // sampled
'[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */

function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  var matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!matches) {
    return undefined;
  }

  var parentSampled;

  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled: parentSampled,
    parentSpanId: matches[2]
  };
}
/**
 * Create tracing context from incoming headers.
 */


function tracingContextFromHeaders(sentryTrace, baggage) {
  var traceparentData = extractTraceparentData(sentryTrace);
  var dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  var _ref = traceparentData || {},
      traceId = _ref.traceId,
      parentSpanId = _ref.parentSpanId,
      parentSampled = _ref.parentSampled;

  var propagationContext = {
    traceId: traceId || uuid4(),
    spanId: uuid4().substring(16),
    sampled: parentSampled === undefined ? false : parentSampled
  };

  if (parentSpanId) {
    propagationContext.parentSpanId = parentSpanId;
  }

  if (dynamicSamplingContext) {
    propagationContext.dsc = dynamicSamplingContext;
  }

  return {
    traceparentData: traceparentData,
    dynamicSamplingContext: dynamicSamplingContext,
    propagationContext: propagationContext
  };
}
/**
 * Create sentry-trace header from span context values.
 */


function generateSentryTraceHeader() {
  var traceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : uuid4();
  var spanId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : uuid4().substring(16);
  var sampled = arguments.length > 2 ? arguments[2] : undefined;
  var sampledString = '';

  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }

  return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}

export { TRACEPARENT_REGEXP, extractTraceparentData, generateSentryTraceHeader, tracingContextFromHeaders };